import axios from 'axios';

const axiosClient = axios.create({
   baseURL: process.env.REACT_APP_BASE_URL,
   // baseURL: 'http://localhost:3000',
    headers: {'partner_id': process.env.REACT_APP_PARTNER_ID}
});

export default axiosClient;
